export default class TableNotes {
  constructor() {
    this.styles = {
      textLeft: { "text-align": "left" },
      textRight: { "text-align": "right" },
      textCenter: { "text-align": "center" },
      width10: { width: "10px !important" },
      textElipsis: {
        "max-width": "10vw !important",
        "word-break": "keep-all !important",
        "white-space": "nowrap !important",
        overflow: "hidden !important",
        "text-overflow": "ellipsis !important",
      },
    };
    this.defaultStyles = {
      padding: "10px",
      "border-style": "none !important",
      "vertical-align": "middle !important",
    };
  }

  spedNotes(notes) {
    const defaultStyles = this.defaultStyles;
    const styles = this.styles;

    const tHeaders = [
      {
        title: "Nº NF",
        name: "numDoc",
        type: "number",
        style: { ...defaultStyles },
      },
      {
        title: "Nome",
        name: "xNome",
        type: "string",
        style: { ...defaultStyles },
      },
      {
        title: "Chave",
        name: "chvNfe",
        type: "string",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "Emissão",
        name: "dtDoc2",
        type: "string",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "VL. Merc.",
        name: "vlMerc",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "VL. Doc.",
        name: "vlDoc",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "ST. Apurado",
        name: "vlIcmsSt",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "Boleto Guia ST",
        name: "guiaSt",
        type: "default",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "Pob. Apurado",
        name: "vlPobreza",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "Boleto Guia Pob.",
        name: "guiaPOb",
        type: "default",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "Danfe",
        name: "danfe",
        type: "default",
        style: { ...defaultStyles, ...styles.textCenter },
      },
    ];

    const tBody = notes.map((item, index) => {
      return {
        line: index,
        idReg0000: item.idReg0000,
        idRegC100: item.idRegC100,
        idNfe: item.idNfe,
        cpfCnpj: item.cpfCnpj,
        numDoc: item.numDoc,
        ser: item.ser,
        codMod: item.codMod,
        xNome: item.xNome,
        chvNfe: item.chvNfe,
        isCalculating: false,
        fornSimples: item.fornSimples,
        aliquota: item.aliquota,
        credOutorgado: item.credOutorgado,
        expanded: false,
        cells: [
          {
            value: item.numDoc,
            style: { ...defaultStyles, ...styles.textLeft },
          },
          {
            value: item.xNome,
            name: "xNome",
            style: { ...defaultStyles, ...styles.textElipsis },
          },
          {
            value: item.chvNfe,
            name: "chvNfe",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          {
            value: item.dtDoc2,
            name: "dtDoc2",
            filter: "date",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          {
            value: item.vProd,
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: item.vNf,
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: item.vlIcmsDar,
            name: "stApurado",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: "guiaSt",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          {
            value: item.vlPobreza,
            name: "pobApurado",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: "guiaPob",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          { value: "danfe", style: { ...defaultStyles, ...styles.textCenter } },
        ],
      };
    });

    return {
      tHeaders,
      tBody,
    };
  }
}
